module.exports = "/assets/bg_tail.webp"